import { Record } from 'immutable';

export default Record({
    payment: 0,
    paymentFreq: 0,
    cashdown: 0,
    rate: 0,
    term: 0,
    total: 0,
    incentives: [],
    feesDisclaimer: '',
    taxesDisclaimer: '',
    taxesDetails: {
        display: true,
        paymentTaxes: 0,
        taxesDetail: '',
        totalPayment: 0,
    },
});



// WEBPACK FOOTER //
// ./src/models/PurchaseTerm.js